/*
 * rusherwang
 * rusherwang@tencent.com
 * create: 2014.4.2
 * update: 2016.6.22
 * Github: https://github.com/powy1993/fullpage
 */

import Store from "../vuex/store"

function FullPage(options) {

  "use strict";
  var headerIsFixed
  var headerIsZhanwei

  var pageContain = document.querySelector(options.el)
  var scrollType = Store.state.app.scrollType
  var isBannerShow = Store.state.myRender.private.banner_isShow
  var footerType = Store.state.myRender.private.fullPageFooterType

  var page = [...document.querySelectorAll('.mybody .layout_row')];
  if (Store.state.myRender.private.banner_isShow) {
    page = [document.querySelector('.myBanner'), ...page]
  }

  var $nav = $('#full-page-nav')
  handleNavVisibility(0)

  var pagelen = page.length,
    sTime = options.slideTime || 800,
    indexNow = options.start || 0,
    browser = {},
    pageRange = {},
    mode = [],
    modeLen,
    navChildren,
    _isLocked = false,
    _isNav = false,
    _t,
    _fix,
    init,
    onTap,
    replaceClass,
    roundPage,
    goPage,
    navChange,
    wheelScroll;


  var isScrolling = false;

  if (!page || pagelen === 0) return;
  if (options.mode) {
    _isNav = options.mode.indexOf('nav:') !== -1;
    mode = options.mode.split(',');
    modeLen = mode.length;
  }

  browser = {
    addEventListener: !!window.addEventListener,
    gravity: !!window.DeviceOrientationEvent,
    version: function () {
      var u = navigator.userAgent,
        matchVersion = u.indexOf('Android'),
        num;

      _fix = u.indexOf('QQBrowser') !== -1 ? 200 : 0;

      if (matchVersion !== -1) {
        num = u.substring(matchVersion + 7, matchVersion + 11).replace(' ', '');
      }
      return num || 0;     //0: not Android device
    }(),
  };

  init = function () {
    if (Store.state.app.view_pattern === 'mb') {
      return
    }

    document.body.classList.add('is-full-page-body')
    document.documentElement.classList.add('is-full-page-html')
    document.documentElement.classList.add('full-page-' + scrollType)
    document.documentElement.scrollTop = 0

    setTimeout(() => {
      // document.documentElement.scrollTop = 0
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }, 200)


    pageRange = {
      X: document.documentElement.clientWidth || window.innerWidth,
      Y: document.documentElement.clientHeight || window.innerHeight
    }

    headerIsFixed = String(Store.state.myRender.common.fixed_header) === 'true'
    headerIsZhanwei = String(Store.state.myRender.private.fullPageTopNavType) === 'zhanwei'
    footerType = Store.state.myRender.private.fullPageFooterType

    if (!headerIsZhanwei) {
      $('.myheader').addClass('header-xuanfu')
    } else {
      $('.myheader').removeClass('header-xuanfu')
    }

    setTimeout(() => {
      fixBannerEditBtnPosition()
      fixLayout(indexNow)
    }, 300)


    if (footerType === 'type0' || footerType === 'typeRow1') {
      setTimeout(() => {
        $('.is-full-page .layout_body').css({
          height: `calc(100% - ${$('.myFooter').height()}px)`
        })
      }, 300)
    } else {
      $(pageContain).css({
        transform: `translateY(0px)`,
      })
    }
    if (Store.state.myRender.private.fullPageFooterType !== 'type1') {
      $('.is-full-page .layout_body').css({
        height: `100%`
      })
    }
    if (Store.state.myRender.private.fullPageFooterType === 'type1') {
      if (indexNow !== page.length - 1) {
        // 不是最后一屏，layout_body高度正常
        $('.is-full-page .layout_body').css({
          height: `100%`
        })
      } else {
        // 最后一屏，让footer滚上来
        setTimeout(() => {
          $('.is-full-page .layout_body').animate({
            height: $('.is-full-page .layout_body').parent().height() - $('.myFooter').height()  /// `calc(100% - ${$('.myFooter').height()}px)`
          }, 200)
          $('.myFooter').addClass('my-footer-active').addClass('jz_page_moveBottomIn')
        })
      }
    }

    // 横向滚动：在最后一屏时，底部类型由rowType1改成hidden，要重置一下最后一个通栏的高度
    if (scrollType === 'row' && footerType === 'hidden') {
      $('.is-full-page .layout_body .layout_row').last().css({
        height: `auto`
      })
    }

  }


  if (browser.addEventListener) {
    if (navigator.userAgent.indexOf('Firefox')) {
      onTap = function (o, fn) {
        o.addEventListener('click', fn, false);
      }
    }
  } else {
    onTap = function (o, fn) {
      o.onclick = fn;
    }
  }

  replaceClass = function (el, cls, tocls) {
    $(el).removeClass(cls)
    $(el).addClass(tocls)
  }

  if (_isNav) {
    navChange = function (from, to) {
      // 把页脚当做最后一页时，没有对应的导航，所以要做一下判断
      if (navChildren[from] && navChildren[to]) {
        $nav.find('.nav-item-active').removeClass('nav-item-active')
        $(navChildren).eq(to).addClass('nav-item-active')
      }
    }
  }

  if (options.continuous) {
    roundPage = function (page) {
      return (pagelen + page % pagelen) % pagelen
    }
  }

  goPage = function (to, triggerType, option = {}) {

    if (to < 0) {
      return
    }


    fixLayout(to)


    var isMac = function (ua) {
        return ua.indexOf('Mac OS') !== -1;
      }(navigator.userAgent),
      fix = _fix,
      indexOld;

    if (options.beforeChange) {
      if (options.beforeChange(indexNow, page[indexNow]) === 'stop') {
        return;
      }
    }

    if (_isLocked                 			// make sure translate is already
      || to === indexNow) return;			// don't translate if thispage

    if (options.continuous) {
      to = roundPage(to, 1);
    } else {
      if (footerType === 'type0' || footerType === 'typeRow1') {
        if (to >= pagelen + 1) {
          return
        }
      }
    }

    _isLocked = true
    isScrolling = true

    // 底部类型：单独高度
    if (footerType === 'type0' || footerType === 'typeRow1') {
      if (to === page.length) {
        // 滑到最后一屏了，继续往下滑，显示页脚
        $('.myFooter').addClass('my-footer-active')
        $(pageContain).css({
          transform: `translateY(-${$('.myFooter').height()}px)`,
        })
        setTimeout(() => {
          _isLocked = false
          isScrolling = false
        }, 500)
        return
      }


      if (triggerType === 'wheelScroll') {
        if (indexNow === page.length - 1 && $('.myFooter').hasClass('my-footer-active')) {
          // 在最后一屏往上滑
          $(pageContain).css({
            transform: `translateY(0px)`,
          })
          setTimeout(() => {
            $('.myFooter').removeClass('my-footer-active')
            _isLocked = false
            isScrolling = false
          }, 500)
          return
        }
      } else {
        // 点击导航
        if (indexNow === page.length - 1 && to === page.length - 1) {
          // 当前页是最后一页、点击到最后一页，不操作
          isScrolling = false
          _isLocked = false
          return
        } else {
          // 其他情况
          $(pageContain).css({
            transform: `translateY(0px)`,
          })
          setTimeout(() => {
            $('.myFooter').removeClass('my-footer-active')
            _isLocked = false
            isScrolling = false
          }, 500)
        }
      }
    }

    // 底部类型：同通栏全屏
    if (Store.state.myRender.private.fullPageFooterType === 'type1') {

      if (to > page.length - 1) {
        isScrolling = false
        _isLocked = false
        return;
      }


      if (to === page.length - 1) {
        // 滚到最后一屏了
        $('.is-full-page .layout_body').animate({
          height: $('.is-full-page .layout_body').parent().height() - $('.myFooter').height()  /// `calc(100% - ${$('.myFooter').height()}px)`
        }, 200)
        $('.myFooter').addClass('my-footer-active').addClass('jz_page_moveBottomIn')

        isScrolling = false
        _isLocked = false
        // return
      } else {
        // 不是最后一屏
        $('.myFooter').removeClass('jz_page_moveBottomIn')
        $('.myFooter').addClass('jz_page_moveTopOut')
        $('.is-full-page .layout_body').css({
          height: `100%`
        })
        setTimeout(() => {
          isScrolling = false
          _isLocked = false
          $('.myFooter').removeClass('my-footer-active')
        }, 600)
      }
    }


    // 底部类型： hidden
    if (Store.state.myRender.private.fullPageFooterType === 'hidden') {
      if (to > page.length - 1) {
        isScrolling = false
        _isLocked = false
        return;
      }
    }

    // 需求变动，不要这个功能了
    if (Store.state.myRender.private.fullPageFooterType === 'typeRow1' && false) {
      if (to > page.length - 1) {
        isScrolling = false
        _isLocked = false
        return;
      }
      if (to === page.length - 1) {
        // 滚到最后一屏了
        // $('.is-full-page .layout_body').animate({
        //   height: $('.is-full-page .layout_body').parent().height() - $('.myFooter').height()  /// `calc(100% - ${$('.myFooter').height()}px)`
        // }, 200)
        $('.is-full-page .layout_body .layout_row').last().css({
          height: `calc(100% - ${$('.myFooter').height()}px)`
        })
        $('.myFooter').addClass('my-footer-active').addClass('jz_page_moveLeftIn')

        isScrolling = false
        _isLocked = false

      } else {
        // 不是最后一屏
        $('.is-full-page .layout_body .layout_row').last().css({
          height: `auto`
        })
        if (indexNow === page.length - 1) {
          // 当前页是最后一屏，从最后一屏切到别的页面
          $('.myFooter').addClass('jz_page_moveRightOut')
          setTimeout(() => {
            $('.myFooter').removeClass('my-footer-active')
            setTimeout(() => {
              $('.myFooter').removeClass('jz_page_moveRightOut')
            }, 400)
          }, 600)
        }
      }

    }

    fix = fix + 20;
    indexOld = indexNow;
    indexNow = to;
    if (_isNav) navChange(indexOld, indexNow);

    setTimeout(function () {
      // fix for bug in ie6-9 about z-index
      page[to] && (page[to].className += ' slide');
    }, fix);


    let oldClass
    let nowClass
    if (scrollType === 'col') {
      if (indexOld < indexNow) {
        oldClass = 'jz_page_moveBottomOut is-old-slide'
        nowClass = 'jz_page_moveBottomIn fullpage-slide-current'
      } else {
        oldClass = 'jz_page_moveTopOut is-old-slide'
        nowClass = 'jz_page_moveTopIn fullpage-slide-current'
      }
    } else {
      if (indexOld < indexNow) {
        oldClass = 'jz_page_moveLeftOut is-old-slide'
        nowClass = 'jz_page_moveLeftIn fullpage-slide-current'
      } else {
        oldClass = 'jz_page_moveRightOut is-old-slide'
        nowClass = 'jz_page_moveRightIn fullpage-slide-current'
      }
    }


    let aniClass = {...Store.state.app.fullPageAniClass}


    if (isScrolling) {
      // 点按导航钮切换的情况，快速点击，上一次翻页可能还没执行完
      Object.keys(aniClass).forEach(key => {
        aniClass[key] = aniClass[key] && oldClass
      })
      clearTimeout(window.timer)
    }

    aniClass[indexOld] = oldClass
    aniClass[indexNow] = nowClass
    Store.commit('app/setFullPageAniClass', aniClass)

    handleNavVisibility(indexNow)

    window.timer = setTimeout(() => {
      aniClass = {
        [indexNow]: 'fullpage-slide-current'
      }
      Store.commit('app/setFullPageAniClass', aniClass)
      isScrolling = false
    }, 800)


    setTimeout(function () {
      replaceClass(page[indexOld], 'fullpage-slide-current', '');

      if (options.callback) {
        options.callback(indexNow, page[indexNow]);
      }

      if (isMac) {
        // Mac电脑多延迟500ms 防止鼠标滚轮事件不断触发导致多翻一页
        setTimeout(function () {
          _isLocked = false;
        }, 500)
      } else {
        _isLocked = false;
      }
    }, sTime + _fix + 120);

  }

  init();


  // Tag first page
  _t = page[indexNow].className;
  page[indexNow].className = _t.indexOf('fullpage-slide-current') !== -1 ? _t : _t + ' fullpage-slide-current';

  if (browser.addEventListener) {
    window.addEventListener('resize', init, false);
  } else {
    window.onresize = init;
  }
  // check mode
  while (modeLen--) {
    (function (m) {
      switch (true) {
        case m === 'wheel' :

          wheelScroll = function (e) {

            var direct;
            e = e || window.event;


            if (e.preventDefault) {
              // e.preventDefault();
            } else {
              e.returnValue = false;
            }

            // 弹窗显示的时候,页面不要滚动
            if (Store.state.left_sidebar.dialogVisible) {
              if ($(e.target).parents('.left_sidebar').length) {
                return;
              }
            }
            if (Store.state.main_dialog.main_dialog_isShow) {
              if ($(e.target).parents('.main_dialog_content').length) {
                return;
              }
            }
            if ($(e.target).parents('.my_navbar .el-dialog').length || $(e.target).parents('.my_add_dialog').length || $(e.target).parents('.el-dialog').length) {
              return;
            }
            if ($(e.target).parents('.material_body').length) {
              return;
            }
            if ($('.row_edit_mongolia').length && $('.row_edit_mongolia').css('display') !== 'none') {
              return;
            }


            if (_isLocked) return;
            direct = -e.wheelDelta || e.detail;
            direct = direct < 0 ? -1 : 1;  // 1是向下，0是向上


            // 自己加的
            var isDown = direct === 1
            var isUp = !isDown
            var elCurrentPageContent = page[indexNow] //.querySelector('.laybox')


            if (elCurrentPageContent && elCurrentPageContent.scrollHeight > elCurrentPageContent.offsetHeight) {
              if ((elCurrentPageContent.scrollTop + elCurrentPageContent.offsetHeight < elCurrentPageContent.scrollHeight - 5) && isDown) {
                return
              }
              if (elCurrentPageContent.scrollTop !== 0 && isUp) {
                return;
              }
            }

            if (isScrolling) {
              return;
            }

            goPage(indexNow + direct, 'wheelScroll');
          }
          if (browser.addEventListener) {
            document.addEventListener('DOMMouseScroll', wheelScroll, false);
          }
          window.onmousewheel = document.onmousewheel = wheelScroll;
          break;

        case m.indexOf('nav:') !== -1 :
          (function () {

            var navId = m.split(':')[1],
              navObj = document.getElementById(navId),
              gotoPage;

            navChildren = navObj.children;

            if (!navObj || !navChildren) return;

            $(navChildren[indexNow]).addClass('nav-item-active')

            gotoPage = function (e) {

              var t;
              e = e || window.event;
              e = e.target || e.srcElement;

              t = e.tagName.toLowerCase();

              while (t !== 'li') {
                if (t === 'ul') return;
                e = e.parentNode;
                t = e.tagName.toLowerCase();
              }

              let index = $(e).index()
              goPage(index, 1);
            }
            // bind event to navObj
            onTap(navObj, gotoPage, 1);
          }());
      }
    }(mode[modeLen]));
  }

  function fixLayout(to) {

    if (Store.state.app.view_pattern === 'mb') {
      return
    }

    if (to !== 0 && !headerIsFixed) {
      $('.myheader').hide()
    } else {
      $('.myheader').show()
    }

    let height = (document.documentElement.clientHeight || window.innerHeight)
    if (Store.state.app.topBarVisible) {
      height = height - $('.topBar').height()
    }

    if (headerIsZhanwei) {
      if (headerIsFixed) {
        height = height - $('.myheader').height()
      } else if (!headerIsFixed) {
        if (to === 0) {
          height = height - $('.myheader').height()
        }
      }
    }

    // 横幅
    $('.is-full-page .myBanner').css({
      height: height
    })

    if (footerType === 'type0' || footerType === 'typeRow1') {
      height = height + $('.myFooter').height()
    }

    pageContain.style.height = height + 'px'
  }

  function handleNavVisibility(indexNow) {
    if (indexNow === 0 && isBannerShow) {
      $($nav).css({
        visibility: 'hidden'
      })
    } else {
      $($nav).css({
        visibility: 'visible'
      })
    }
  }

  function fixBannerEditBtnPosition() {
    headerIsZhanwei = String(Store.state.myRender.private.fullPageTopNavType) === 'zhanwei'
    if (!headerIsZhanwei) {
      $('.full_screen_banner .edit_tool_banner').css({
        top: $('.myheader').height()
      })
    } else {
      $('.full_screen_banner .edit_tool_banner').css({
        top: 0
      })
    }
  }

  return {
    getSlideList() {
      return page
    },
    thisPage: function () {
      return indexNow;
    },
    go: function (num) {
      goPage(num);
    },
    goLastPage() {
      let num = page.length - 1
      goPage(num)
      setTimeout(() => {
        $('.myFooter').addClass('my-footer-active')
        // 需求变动，不要这个功能了
        // let isRow = scrollType === 'row'
        // let footerIsShow = String(Store.state.myRender.common.footer_display) === 'true'
        // if (isRow && footerIsShow && Store.state.myRender.private.fullPageFooterType === 'typeRow1') {
        //   $('.myFooter').addClass('my-footer-active').addClass('jz_page_moveLeftIn')
        // }
      })
    },
    goLastPageOrFooter() {
      let num = page.length
      goPage(num - 1)
      setTimeout(() => {
        goPage(num)
      }, 400)
    },
    next: function () {
      goPage(indexNow + 1);
    },
    prev: function () {
      goPage(indexNow - 1);
    },
    toggleBannerVisible: function (visible) {
      this.resetData();
      this.resetHeight();

      if (visible) {
        indexNow = 1
        goPage(0)
      } else {
        indexNow = 0
        $('.myBanner').removeClass('fullpage-slide-current')
        $('.is-full-page .layout_body .layout_row').eq(0).addClass('fullpage-slide-current')
        $nav.find('.nav-item-active').removeClass('nav-item-active')
        $nav.find('li').eq(0).addClass('nav-item-active')
      }
      handleNavVisibility(indexNow)
    },
    resetHeight: function () {
      init()
    },
    resetData: function () {
      page = [...document.querySelectorAll('.mybody .layout_row')];
      if (Store.state.myRender.private.banner_isShow) {
        page = [document.querySelector('.myBanner'), ...page]
      }
      pagelen = page.length
      isBannerShow = Store.state.myRender.private.banner_isShow
    },
    removeSlide(index, row) {
      if (row.rowType !== 'body') {
        this.resetHeight()
        return
      }

      this.resetData()

      // 如果是最后一屏，显示前一屏
      if (index === pagelen - 1) {
        goPage(index - 1)
      }

      // 如果是第0到len-1屏，删了后跳到下一屏
      if (index < pagelen - 1) {
        goPage(index)
      }

      setTimeout(() => {
        // $(page[index]).remove()
        this.resetData()
      }, 1500)

      // goPage(indexNow + 1);
    },
    handleSlideSortUp() {
      setTimeout(() => {
        this.resetData()
        this.prev()
      }, 20)
    },
    handleSlideSortDown() {
      setTimeout(() => {
        this.resetData()
        this.next()
      }, 20)
    },
    unbind() {
      document.removeEventListener('DOMMouseScroll', wheelScroll)
      window.onmousewheel = document.onmousewheel = null
      window.removeEventListener('resize', init)
      window.onresize = null
    },
    destroy() {
      this.unbind()
      document.body.classList.remove('is-full-page-body')
      document.documentElement.classList.remove('is-full-page-html')
      document.documentElement.classList.remove('full-page-' + scrollType)
      $('.fullpage-slide-current').removeClass('fullpage-slide-current')
      Store.commit('app/setFullPageCurrentIndex', 0);
      Store.commit('app/setFullPageAniClass', {})
      $(pageContain).css({
        transform: `translateY(0px)`,
      })
      $('.mybody').css({
        height: 'auto'
      })
      $('.is-full-page .layout_body .layout_row').last().css({
        height: 'auto'
      })
      if (Store.state.app.view_pattern === 'mb') {
        $('.mb_body_view').css({
          height: `617px`,
        })
        $('.myBanner').height('auto')
        // 修复bug：切换到手机视图后，backTop按钮位置会跟着页面滚动。原因：祖先元素transform不为none时，position:fixed失效。
        $('.mb_body_view').css({
          transform: 'none'
        })
      }
    }
  }
}


export default FullPage



// WEBPACK FOOTER //
// ./src/base/fullPage.js